import request from '@/utils/request'

export function createHomework(data) {
  return request({
    url: '/amc/homework',
    method: 'post',
    data
  })
}

export function updateHomework(id, data) {
  return request({
    url: `/amc/homework/${id}`,
    method: 'put',
    data
  })
}

export function deleteHomework(id) {
  return request({
    url: `/amc/homework/${id}`,
    method: 'delete'
  })
}

export function teacherHomeworkList(courseId) {
  return request({
    url: '/amc/homework/teacher-list',
    method: 'get',
    params: { courseId }
  })
}

export function getHomeworkDetail(id) {
  return request({
    url: `/amc/homework/${id}`,
    method: 'get'
  })
}

export function getHomeworkStats(id) {
  return request({
    url: `/amc/homework/${id}/stats`,
    method: 'get'
  })
}

export function studentHomeworkList(courseId) {
  return request({
    url: '/amc/homework/student-list',
    method: 'get',
    params: { courseId }
  })
}

export function startHomework(id) {
  return request({
    url: `/amc/homework/${id}/start`,
    method: 'post'
  })
}

export function submitHomework(id, payload) {
  return request({
    url: `/amc/homework/${id}/submit`,
    method: 'post',
    data: payload
  })
}

export function submitHomeworkAnswers(id, answers) {
  return request({
    url: `/amc/homework/${id}/submit-answers`,
    method: 'post',
    data: { answers }
  })
}

export function getMyHomeworkAnswers(id) {
  return request({
    url: `/amc/homework/${id}/my-answers`,
    method: 'get'
  })
}

// 更新解析查看时长
export function updateAnalysisViewDuration(homeworkId, duration) {
  return request({
    url: `/amc/homework/${homeworkId}/analysis-view-duration`,
    method: 'post',
    data: { duration }
  })
}
